import { ThunkResult } from '../../store'
import palletApi, { PalletStatus } from '../../apis/pallet.api'
import palletService from '../../services/pallet.service'
import { replaceResult, replaceResultData } from './BarePallets.slice'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search, startAt, endAt } = getState().barePallets
    const status: PalletStatus = 'bare'
    const params = { page, limit, search, status, startAt, endAt }
    palletApi.paginateInventories(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}

export function deletePallet (id: number): ThunkResult<void> {
  return (dispatch, getState) => {
    palletApi.delete(id, item => {
      if (!item) return
      const { result } = getState().barePallets
      const data = palletService.delete(result.data, id)
      dispatch(replaceResultData(data))
    })
  }
}
